var EPK = EPK || {};
EPK.BrandCouponLp = EPK.BrandCouponLp || {};

/**
 * @class EPK.CouponLp
 * クーポンLPの表示制御
 */
EPK.BrandCouponLp = function () {
	this.statusFlag;
	this.getCouponList;
	this.checkedList;
};

/**
 * #12258 WebCM
 * @method init
 * LP、初期化、イベント付与
 */
EPK.BrandCouponLp.init = function () {
	
	var couponBtn = document.getElementById('couponBtn');
	var couponRequest = document.getElementById('couponRequestBtn');
	var singleCouponBtn = document.getElementById('singleCouponRequestBtn');

	// EPARKポイントを取得する
	EPK.BrandCouponLp.getEparkPoint();

	//アプリから遷移してきた場合に遷移先をアプリに変更する
	EPK.BrandCouponLp.appRedirect();

	// クーポン取得ボタンモーダル
	if (couponBtn) {
		EPK.BrandCouponLp.showGetCouponModal(couponBtn);
	}

	// クーポン仮取得
	if (couponRequest) {
		couponRequest.addEventListener('click', function() {
			EPK.BrandCouponLp.AcceptCoupon();
		});
	}

	//クーポン単品仮取得
	if (singleCouponBtn) {
		singleCouponBtn.addEventListener('click',function (event) {
			EPK.BrandCouponLp.getSingleCouponAPI(event);
		},false);
	}
};

/**
 * #12258 WebCM
 * @method getSingleCouponAPI
 * LP 商品詳細　単品クーポン取得
 */
EPK.BrandCouponLp.getSingleCouponAPI = function (event) {
	var _this = this;
	var coupon_id = EPK.common.params.coupon_id;
	var url;
	var targetCoupon = event.currentTarget;
	var chageText ='<div class="btn-coupon-get is-disabled">\n'+
						'<a href="javascript:void(0)"><img src="/mobile/img/lp/cp-kyorindo-2010/btn_single_coupon_acquired.png" alt=""></a>\n'+
					'</div>';

	if (!coupon_id) {
		return;
	}

	url = '/coupon/acceptLp/' + coupon_id + '/0';
	$.ajax({
		url: url,
		type: 'POST',
		data: {},
		cache: false,
		dataType : "json",
	}).done(function (data) {

		if (data && data.result && String(data.result.status)) {
			result = data.result.status;

			if (!EPK.common.isMobile) {
				if (result == '1') {

					// 完了モーダルの表示
					$.magnificPopup.close();
					$.magnificPopup.open({
						items: {src: '#modal-brand-coupon_request_complete'},
						type: 'inline',
						modal: true,
						callbacks: {
							close: function(){
								location.reload();
							}
						},
					}, 0);
				} else {
					// エラーモーダルの表示
					$.magnificPopup.close();
					$.magnificPopup.open({
						items: {src: '#modal-brand-coupon_request_error'},
						type: 'inline',
						modal: true,
						callbacks: {
							close: function(){
								location.reload();
							}
						},
					}, 0);
					_this.statusFlag = false;
				}
			} else {
				if (result == '1' ) {
					// マイページクーポン画面へリダイレクト
					if (EPK.BrandCouponLp.appFlag && EPK.BrandCouponLp.appFlag != '-1') {
						//#12606 クーポン仮取得 アプリ連携
						targetCoupon.insertAdjacentHTML('afterend',chageText);
						targetCoupon.parentNode.removeChild(targetCoupon);
						location.href = 'kusuriapp://Coupon';
					} else {
						location.href = '/member/coupon';
					}
				} else {
					// エラーモーダルの表示
					$.magnificPopup.close();
					$.magnificPopup.open({
						items: {src: '#modal-brand-coupon_request_error'},
						type: 'inline',
						modal: true,
						callbacks: {
							close: function(){
								location.reload();
							}
						}
					}, 0);
				}
			}
		}
		
	}).fail(function (data) {
		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {src: '#modal-brand-coupon_request_error'},
			type: 'inline',
			modal: true,
			callbacks: {
				close: function(){
					location.reload();
				}
			}
		}, 0);
	})
};

/**
 * #12258 WebCM
 * @method AcceptCoupon
 * LP TOP 商品詳細　複数同時クーポン取得　パラメータ生成
 */
EPK.BrandCouponLp.AcceptCoupon = function () {

	var _this = this;
	if (EPK.common.action == 'display') {
		_this.checkedList = document.querySelectorAll('#modalCouponSelect ul.list input:checked');
	} else if(EPK.common.action == 'detail') {
		_this.checkedList = document.querySelectorAll('section.coupon-select ul.coupon-select-list input:checked');
	}

	var coupon_id = '';
	var url;
	_this.statusFlag = true;
	_this.getCouponList = [];


	if (_this.checkedList.length > 0) {
		for (var i = 0; i < _this.checkedList.length; i++) {
			coupon_id = _this.checkedList[i].value;
			url = '/coupon/acceptLp/' + coupon_id + '/0';
			
			if (_this.statusFlag) {
				EPK.BrandCouponLp.getCouponAPI(coupon_id,url);
			} else { 
				break;
			}
		}
	}
};

/**
 * #12258 WebCM
 * @method AcceptCoupon
 * LP TOP 商品詳細　複数同時クーポン取得　サーバとの通信
 */
EPK.BrandCouponLp.getCouponAPI = function (couponId,url) {
	var _this = this;
	var result;

	$.ajax({
		url: url,
		type: 'POST',
		data: {},
		cache: false,
		dataType : "json",
		async: false
	}).done(function(data, textStatus, jqXHR){

		if (data && data.result && String(data.result.status)) {
			result = data.result.status;

			if (!EPK.common.isMobile) {
				// 完了モーダルの表示
				if (result == '1' ) {
					_this.getCouponList.push(couponId);
					_this.statusFlag = true;
					if (_this.getCouponList.length == _this.checkedList.length) {
						$.magnificPopup.close();
						$.magnificPopup.open({
							items: {src: '#modal-brand-coupon_request_complete'},
							type: 'inline',
							modal: true,
							callbacks: {
								close: function(){
									location.reload();
								}
							},
						}, 0);
					}
				} else {
					// エラーモーダルの表示
					$.magnificPopup.close();
					$.magnificPopup.open({
						items: {src: '#modal-brand-coupon_request_error'},
						type: 'inline',
						modal: true,
						callbacks: {
							close: function(){
								location.reload();
							}
						},
					}, 0);
					_this.statusFlag = false;
				}
			} else {
				// マイページクーポン画面へリダイレクト
				if (result == '1' ) {
					_this.getCouponList.push(couponId);
					_this.statusFlag = true;
					if (_this.getCouponList.length == _this.checkedList.length) {

						//#12606 クーポン仮取得 アプリ連携
						if (EPK.BrandCouponLp.appFlag && EPK.BrandCouponLp.appFlag != '-1') {
							//LPTOP クーポンを取得済み状態に変更する
							if (EPK.common.action == 'display') {
								var modal = document.getElementById('modalCouponSelect');
								var couponList = modal.querySelector('ul.list');
								if (modal && couponList) {
									for (var i = 0; i < _this.getCouponList.length; i++) {
										var targetCoupon = couponList.querySelector('input[value="'+_this.getCouponList[i]+'"]');
										
										if (targetCoupon) {
											targetCoupon.setAttribute('disabled',true);
											targetCoupon.checked = false;
										}
									}
								}
								//すべて取得ができていた場合はクーポン取得ボタンを非活性にする。
								var disableCoupon = [];
								var couponEl = couponList.querySelectorAll('li');
								for (var i = 0; i < couponEl.length; i++) {
									if (couponEl[i].querySelector('input').disabled) {
										disableCoupon.push(couponEl[i]);
									}
								}
								if (couponEl.length == disableCoupon.length) {
									var couponBtn = document.querySelectorAll('div.coupon-btn');
									var chageBtn = '<div class="coupon-btn">\n' +
														'<a href="javascript:void(0);" class="is-disabled "><img src="/mobile/img/lp/cp-kyorindo-2010/coupon_comp_btn.png" alt="クーポン取得"></a>\n' +
														'<p class="sub">※クーポン取得時はポイントと交換されません。</p>\n' +
													'</div>';
									$.magnificPopup.close();
									if (couponBtn.length > 0) {
										for (var i = 0; i < couponBtn.length; i++) {
											couponBtn[i].insertAdjacentHTML('afterend',chageBtn);
											couponBtn[i].parentNode.removeChild(couponBtn[i]);
										}	
									}
								}
							}

							//クーポン詳細 クーポンを取得済み状態に変更する
							if (EPK.common.action == 'detail') {
								var couponList = document.querySelector('section.coupon-select ul.coupon-select-list');
								if (couponList) {
									for (var i = 0; i < _this.getCouponList.length; i++) {
										var targetCoupon = couponList.querySelector('input[value="'+_this.getCouponList[i]+'"]');
										
										if (targetCoupon) {
											targetCoupon.setAttribute('disabled',true);
											targetCoupon.checked = false;
											if (targetCoupon.nextElementSibling.classList.contains('coupon-img')) {
												targetCoupon.nextElementSibling.classList.add('coupon-end');
											}
										}
									}
								}
								var disableCoupon = [];
								var couponEl = couponList.querySelectorAll('li');
								for (var i = 0; i < couponEl.length; i++) {
									if (couponEl[i].querySelector('input').disabled) {
										disableCoupon.push(couponEl[i]);
									}
								}
								if (couponEl.length == disableCoupon.length) {
									var changeBtn = document.querySelector('div.btn-coupon-get.get-all img');
									if (changeBtn) {
										changeBtn.setAttribute('src','/mobile/img/lp/cp-kyorindo-2010/btn_multiple_coupon_acquired.png');
									}
								}
							}

							location.href = 'kusuriapp://Coupon';

						} else {
							location.href = '/member/coupon';
						}
					}

				} else {
					// エラーモーダルの表示
					$.magnificPopup.close();
					$.magnificPopup.open({
						items: {src: '#modal-brand-coupon_request_error'},
						type: 'inline',
						modal: true,
						callbacks: {
							close: function(){
								location.reload();
							}
						}
					}, 0);
					_this.statusFlag = false;
				}
			}
		}

	}).fail( function(data) {
		// エラーモーダルの表示
		_this.statusFlag = false;
		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {src: '#modal-brand-coupon_request_error'},
			type: 'inline',
			modal: true,
			callbacks: {
				close: function(){
					location.reload();
				}
			}
		}, 0);
	});
};

/**
 * #12258 WebCM
 * @method getEparkPoint
 * LP ユーザー所持ポイントの取得と描画
 */
EPK.BrandCouponLp.getEparkPoint = function () {
	var _this = this;

	// 保有しているEPARKポイントの取得
	var userPoint = document.getElementById('userPoint');
	if(!userPoint){
		return true;
	}
	// ログイン時のみ
	if(!EPK.common.isLogin){
		return true;
	}

	$.ajax({
		url: '/api/member/eparkpoint',
		type: 'get',
		data: {
		},
		cache: false,
		dataType: 'json',
		timeout: 100000
	})
	.done(function(data) {
		if (data.status == 1) {
			var user_epark_point = EPK.BrandCouponLp.numSeparate(data['epark_point']);
			userPoint.innerHTML = user_epark_point ;
		} else {
			console.log('failed');
			console.log(data);
		}
	}).fail(function (data) {
		//何もしない
	});
};

/**
 * 数値のカンマ編集
 */
EPK.BrandCouponLp.numSeparate = function(num) {
	num = String(num);

	var strMinus = '';
	if (num.indexOf('-') > -1) {
		strMinus = '-';
	}

	num = num.replace(/-/g, '');
	var len = num.length;

	if (len > 3) {
		// 前半を引数に再帰呼び出し + 後半3桁
		return strMinus + this.numSeparate(num.substring(0, len - 3)) + ',' + num.substring(len - 3);
	} else {
		return strMinus + num;
	}
};

/**
 * #12258 WebCM
 * @method showGetCouponModal
 * LP クーポン取得モーダルの表示
 */
EPK.BrandCouponLp.showGetCouponModal = function (btnEl) {
	if (!btnEl) return;

	var targetModal

	if (EPK.common.isLogin) {
		targetModal = '#modalCouponSelect'
	} else {
		targetModal = '#modalLogin'
	}

	btnEl.addEventListener('click',function () {
		$.magnificPopup.open({
			items: {src: targetModal},
			type: 'inline',
			modal: true
		}, 0);
	})
};

/**
 * #12606 クーポン仮取得 アプリ連携
 * @method appRedirect
 * アプリからの遷移はアプリに遷移させる
 */
EPK.BrandCouponLp.appRedirect = function () {
	
	EPK.BrandCouponLp.queryParams = location.search;
	EPK.BrandCouponLp.appFlag;
	var couponDetails,myPageLink;

	if (!EPK.BrandCouponLp.queryParams) {
		return;
	}

	if (EPK.common.isSP && EPK.BrandCouponLp.queryParams) {
		EPK.BrandCouponLp.appFlag = EPK.BrandCouponLp.queryParams.indexOf('utm_source=kusurinomadoguchi_app');
		if (EPK.BrandCouponLp.appFlag != '-1') {
			couponDetails = document.querySelectorAll('.target-item .itembox > a');
			myPageLink = document.querySelectorAll('p.mypagelink a');
			if (couponDetails.length > 0) {
				for (var i = 0; i < couponDetails.length; i++) {
					var link = couponDetails[i].getAttribute('href');
					couponDetails[i].setAttribute('href',link + EPK.BrandCouponLp.queryParams);
				}
			}
			if (myPageLink.length > 0) {
				for (var i = 0; i < myPageLink.length; i++) {
					myPageLink[i].setAttribute('href','kusuriapp://Coupon');
				}
			}
		}
	}	
};

$(function(){

	EPK.BrandCouponLp.init();
});

